const userTypes = { FASTEX_USER: 1, CUSTOMER_USER: 2, MOBILE_USER: 3, STORAGE_USER: 4 };

export const UserTypes = Object.freeze(userTypes);
